import React, { useState } from "react";
import { DashboardLayout } from "@layouts/DashboardLayout";
import { DeveloperRequests } from "@pages/DeveloperRequests";
import { Requests } from ".";
import { useSessionStorage } from "../../hooks";

const AllRequests = () => {
  const [user] = useSessionStorage("user", {});
  const [activeTab, setActiveTab] = useState("property");

  return (
    <div>
      <DashboardLayout>
        {/* <div className="row mb-3">
          <h3 className="fw-bold mb-1">Requests</h3>
          <p className="text-secondary fs-14">
            Manage all requests on your property
          </p>
        </div> */}

        {user?.role !== "property-manager" ? (
          <>
            <ul className="nav nav-pills mb-3">
              <li className="nav-item">
                <button
                  className={`nav-link ${activeTab === "property"
                      ? "active text-white bg-success"
                      : "text-success"
                    }`}
                  onClick={() => setActiveTab("property")}
                >
                  Property Requests
                </button>
              </li>
              <li className="nav-item">
                <button
                  className={`nav-link ${activeTab === "developer"
                      ? "active text-white bg-success"
                      : "text-success"
                    }`}
                  onClick={() => setActiveTab("developer")}
                >
                  Developer Requests
                </button>
              </li>
            </ul>

            <div>
              {activeTab === "property" && <Requests />}
              {activeTab === "developer" && <DeveloperRequests />}
            </div>
          </>
        ) : (
          <div>
            <Requests />
          </div>
        )}
      </DashboardLayout>
    </div>
  );
};

export default AllRequests;
